import React from 'react';
import DravonixHero from './components/DravonixHero';
import ProtocolSection from './components/ProtocolSection';
import Services from './components/Services';
import Projects from './components/Projects';
import Partners from './components/Partners';
import Stats from './components/Stats';
import Advantages from './components/Advantages';
import TechStack from './components/TechStack';
import Process from './components/Process';
import CTA from './components/CTA';
import Connect from './components/Connect';
import Footer from './components/Footer';
import CommandDock from './components/CommandDock';
import FloatingButtons from './components/FloatingButtons';

/**
 * Dravonix Website - Main Application
 * 
 * Sections Order:
 * 1. Hero - Intro animation
 * 2. Protocol - Who We Are
 * 3. Services - What We Build
 * 4. Projects - Our Work
 * 5. Partners - Trusted Partners
 * 6. Stats - Track Record
 * 7. Advantages - Why Dravonix
 * 8. TechStack - Technologies
 * 9. Process - How We Build
 * 10. CTA - Ready to Build
 * 11. Connect - Social Media
 * 12. Footer
 */

function App() {
  return (
    <div className="dravonix-app">
      {/* Left Navigation Dock */}
      <CommandDock />
      
      {/* Floating WhatsApp & Telegram Golden Orbs */}
      <FloatingButtons />

      {/* Hero Section */}
      <section id="hero">
        <DravonixHero />
      </section>
      
      {/* Protocol Section - "Who We Are" */}
      <ProtocolSection />
      
      {/* Services Section - "What We Build" */}
      <Services />
      
      {/* Projects Section - "Our Work" */}
      <Projects />
      
      {/* Partners Section - "Trusted Partners" */}
      <Partners />
      
      {/* Stats Section - "Track Record" */}
      <Stats />
      
      {/* Advantages Section - "Why Dravonix" */}
      <Advantages />
      
      {/* Tech Stack Section - "Technologies" */}
      <TechStack />
      
      {/* Process Section - "How We Build" */}
      <Process />
      
      {/* CTA Section - "Ready to Build" */}
      <CTA />
      
      {/* Connect Section - "Social Media" */}
      <Connect />
      
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
